// Composition root for the router-driven app shell.

import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { readEnv } from '@/shared/config';
import { routes } from './routes';

// Build the router once at module scope. createBrowserRouter is
// stateful and React Router warns when it is recreated on every render.
const basename = (readEnv('BASE_URL', '/') ?? '/').replace(/\/$/, '') || '/';
const router = createBrowserRouter(routes, { basename });

export function AppRouter() {
  return <RouterProvider router={router} />;
}
